import { DataTable } from "@/components/DataTable";
import { PageLoader } from "@/components/PageLoader";
import { TableWrapper } from "@/components/TableWrapper";
import { useTrackedQuery } from "@/hooks/useTrackedQuery";
import { getERNSforJob } from "@/lib/supabase/edge-functions/erns";
import { withJob } from "../withJob";
import { ernTableColumns, ERNTableRow } from "./erns-table-columns";

export const ERNs = withJob(({ job }) => {
  const ernQuery = useTrackedQuery({
    queryKey: ["salesOrderTrackingData", job.number, "erns"],
    queryFn: () => getERNSforJob(job.number),
  });

  // Handle loading and error states
  if (ernQuery.isError) return `Error loading ERNs: ${ernQuery.error.message}`;
  if (ernQuery.isPending) return <PageLoader text="Loading ERNs" />;

  // Flatten the list of ERNs into a list of table rows (one row for each BOM line item)
  const data = ernQuery.data.flatMap((ern) =>
    ern.bomData.map<ERNTableRow>((line, index) => ({
      rowId: `ern-${ern.number}-line-${index.toFixed()}`,
      ern,
      line,
    })),
  );

  return (
    <TableWrapper className="col">
      <DataTable bordered data={data} columns={ernTableColumns} getRowId={({ rowId }) => rowId} />
    </TableWrapper>
  );
});
